import "malihu-custom-scrollbar-plugin";
import "jquery-mousewheel";

$(".js-custom-scrollbar").mCustomScrollbar({
  theme: "custom-scrollbar",
  setTop: 0,
});

const lightConfig = {
  theme: "light-thin",
  scrollInertia: 0,
};
$(".custom-scrollbar-light").mCustomScrollbar({
  ...lightConfig,
  axis: "x",
  mouseWheel: {
    axis: "x",
    invert: true,
  },
});
$(".custom-scrollbar-light--vertical").mCustomScrollbar({
  ...lightConfig,
  axis: "y",
  mouseWheel: {
    axis: "y",
    invert: false,
  },
});
